import { __rest } from "tslib";
import clsx from 'clsx';
import { createElement, forwardRef } from 'react';
import { atoms } from '../../../css/atoms/atoms';
import { sprinkles } from '../../../css/atoms/sprinkles.css';
import { useDataEnv } from '../../../hooks/useDataEnv/useDataEnv';
import { buildDataAttributes } from '../../../library/props/buildDataAttributes';
import { resolveResponsivePropSafe } from '../../../library/props/responsiveProp';
import * as styles from './Box.css';
import { resolveColorPropsFromScheme } from './boxColorSchemes';
import { textPropsPreset } from './textPropsPreset';
export const boxPaddingNames = ['padding', 'paddingX', 'paddingY', 'paddingTop', 'paddingBottom', 'paddingLeft', 'paddingRight'];
export const boxMarginNames = ['margin', 'marginX', 'marginY', 'marginTop', 'marginBottom', 'marginLeft', 'marginRight'];
export const Box = /*#__PURE__*/forwardRef((_a, ref) => {
  var {
    component = 'div',
    className,
    colorScheme,
    fontColor,
    backgroundColor,
    border,
    textPreset,
    dataAttributes,
    dataTrack,
    dataTest,
    debugName,
    dataI,
    dataT
  } = _a,
      props = __rest(_a, ["component", "className", "colorScheme", "fontColor", "backgroundColor", "border", "textPreset", "dataAttributes", "dataTrack", "dataTest", "debugName", "dataI", "dataT"]);

  const colorPropsFromScheme = resolveColorPropsFromScheme(colorScheme);
  const atomProps = Object.assign({}, typeof textPreset !== 'undefined' ? textPropsPreset[textPreset] : {}, typeof fontColor !== 'undefined' ? {
    color: fontColor
  } : {
    color: colorPropsFromScheme.fontColor
  }, typeof backgroundColor !== 'undefined' ? {
    background: backgroundColor
  } : {
    background: colorPropsFromScheme.backgroundColor
  });
  const nativeProps = {};

  for (const key in props) {
    if (sprinkles.properties.has(key)) {
      atomProps[key] = props[key];
    } else {
      nativeProps[key] = props[key];
    }
  }

  const combinedClasses = clsx(atoms(atomProps, typeof component === 'string' ? component : 'div'), resolveResponsivePropSafe(border !== null && border !== void 0 ? border : colorPropsFromScheme.border, styles.border), className);
  return createElement(component, Object.assign(Object.assign(Object.assign(Object.assign({
    className: combinedClasses.length === 0 ? undefined : combinedClasses.trim()
  }, nativeProps), useDataEnv(debugName, dataTest, dataTrack)), buildDataAttributes(dataAttributes, dataI, dataT)), {
    ref
  }));
});
Box.displayName = 'Box';
//# sourceMappingURL=Box.js.map